// extracted by mini-css-extract-plugin
module.exports = {"OnScreenKeyboard":"OnScreenKeyboard_OnScreenKeyboard__3rpDH","keyboard":"OnScreenKeyboard_keyboard__3HswX","number":"OnScreenKeyboard_number__3z-7S"};